import { RouterProvider } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import appRouter from './routers/appRouter'
import { AuthProvider } from './contexts/AuthContext'
import NetworkErrorBoundary from './hooks/NetworkErrorBoundary'
import { useDevToolsGuard } from './hooks/useDevToolsGuard'

function App() {
  useDevToolsGuard()
  return (
    <div className="App">
      <AuthProvider>
        <NetworkErrorBoundary>
          <RouterProvider router={appRouter} />
        </NetworkErrorBoundary>
      </AuthProvider>
      <ToastContainer containerId="default" />
    </div>
  )
}

export default App
